
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class RewardsMasterDialog extends Serenity.EntityDialog<RewardsMasterRow, any> {
        protected getFormKey() { return RewardsMasterForm.formKey; }
        protected getIdProperty() { return RewardsMasterRow.idProperty; }
        protected getLocalTextPrefix() { return RewardsMasterRow.localTextPrefix; }
        protected getNameProperty() { return RewardsMasterRow.nameProperty; }
        protected getService() { return RewardsMasterService.baseUrl; }
        protected getDeletePermission() { return RewardsMasterRow.deletePermission; }
        protected getInsertPermission() { return RewardsMasterRow.insertPermission; }
        protected getUpdatePermission() { return RewardsMasterRow.updatePermission; }
        protected useViewMode() { return true; }


        protected form = new RewardsMasterForm(this.idPrefix);

        constructor() {
            super();
            this.form.RewardsDetails.getGridField().find('.caption').attr("style", "display:none;");



            this.form.ProductWise.changeSelect2(e => {
                if (this.form.ProductWise.value == true) {
                    Serenity.EditorUtils.setReadOnly(this.form.RewardsDetails, false);
                    this.form.RewardsDetails.EnableAddButton();
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.RewardsDetails, true); 
                    this.form.RewardsDetails.DisableAddButton();
                }
            });

            //var id = RewardsMasterRow.getLookup().items.filter(x => x.RewardCode.toUpperCase() == this.form.RewardCode.value)[0];

            let id;
            OMS.RewardsMasterService.GetRewards({ RewardCode: this.form.RewardCode.value },
                response => {
                    id = response.Entities[0];
                }, { async: false });
            if (id != undefined) {
                Q.notifyError("Not Found " + this.form.RewardCode.value);
                this.form.RewardCode.value = "";
                return;

            }
            else {
                this.form.RewardCode.value = this.form.RewardCode.value.toUpperCase();
            }

        }

        protected onDialogOpen() {
            super.onDialogOpen();
            //this.form.HasBom.changeSelect2(e => {
            if (this.form.ProductWise.value == true) {
                Serenity.EditorUtils.setReadOnly(this.form.RewardsDetails, false);
                this.form.RewardsDetails.EnableAddButton();


            } else {
                Serenity.EditorUtils.setReadOnly(this.form.RewardsDetails, true);
                this.form.RewardsDetails.DisableAddButton();
            }

        }


    }
}
